import { PropTypes } from 'prop-types'

import { Area } from '../../models/areas/area-enum'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { areaDefinitionPropType } from './area-definition-prop-type'
import { areaSchedulePropType } from './area-schedule-prop-type'
import { areaSpeedProfilePropType } from './area-speed-profile-prop-type'

export const areaPropType = PropTypes.shape({
    [Area.ACTIVE_STATUS]: PropTypes.string,
    [Area.AREA_ID]: PropTypes.string,
    [Area.AREA_DEFINITION]: areaDefinitionPropType,
    [Area.EVENT_LEVEL_ENTER]: PropTypes.string,
    [Area.EVENT_LEVEL_INSIDE]: PropTypes.string,
    [Area.EVENT_LEVEL_LEAVE]: PropTypes.string,
    [Area.EVENT_LEVEL_OUTSIDE]: PropTypes.string,
    [Area.GEO_FENCING_NOTIFICATION_TYPE]: PropTypes.string,
    [Area.NAME]: PropTypes.string,
    [Area.NUMBER]: PropTypes.string,
    [Area.SCHEDULE_DAYS]: PropTypes.arrayOf(PropTypes.string),
    [Area.SCHEDULES]: PropTypes.arrayOf(areaSchedulePropType),
    [Area.SPEED_PROFILES]: PropTypes.arrayOf(areaSpeedProfilePropType),
    [Area.VALID_FROM]: iso8601PropType,
    [Area.VALID_TO]: iso8601PropType
})
